import { FC } from 'react';

import View from './view';

const UserWorkSpaceProvisionRequestPage: FC = () => {
  return <View />;
};
export default UserWorkSpaceProvisionRequestPage;
